import type { Ref } from "vue";
import { ref, watch } from "vue";

import { useUserStore } from "@/App/user/user.store";

export const useTimedSession = (): {
  onTimeout: () => void;
  timedSessionOn: Ref<boolean>;
  timeoutTime: Ref<number>;
} => {
  const userStore = useUserStore();

  const onTimeout = (): void => {
    userStore
      .logout({ reason: "Session timed out" })
      .catch((reason) => console.warn(`Failed to logout (session timed out): ${reason}`));
  };

  const timedSessionOn = ref(false);

  const timeoutTime = ref(0);

  watch(
    () => userStore.user,
    () => {
      const dashboardSessionInactivityTimeout = userStore.user?.sessionInactivityTimeout?.dashboard ?? 0;

      timedSessionOn.value = !!dashboardSessionInactivityTimeout;

      timeoutTime.value = dashboardSessionInactivityTimeout;
    },
    { immediate: true },
  );

  return { onTimeout, timedSessionOn, timeoutTime };
};
